import { render, staticRenderFns } from "./CardSign.vue?vue&type=template&id=490c3860&scoped=true&"
import script from "./CardSign.vue?vue&type=script&lang=js&"
export * from "./CardSign.vue?vue&type=script&lang=js&"
import style0 from "./CardSign.vue?vue&type=style&index=0&id=490c3860&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c3860",
  null
  
)

export default component.exports